import script from "./SfxTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxTabs.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs});
